(function () {
  function formatMoney(cents, locale, currency) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  document.addEventListener('change', function (e) {
    const target = e.target;
    if (!target.matches('input[name^="options"]')) return;

    const selectedValue = target.value.trim();
    const variants = window.meta?.product?.variants || [];

    const matchedVariant = variants.find(v =>
      v.public_title === selectedValue || v.options?.[0] === selectedValue
    );

    if (!matchedVariant) return;

    // Variant-ID setzen (Cart / Checkout)
    const idInput = document.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = matchedVariant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Preis aktualisieren
    const priceEl = document.querySelector('[data-main-price]');
    if (!priceEl) return;

    const locale =
      document.documentElement.lang === 'de'
        ? 'de-AT'
        : navigator.language || 'de-AT';

    const currency =
      window.Shopify?.currency?.active ||
      window.Shopify?.currency?.active ||
      'EUR';

    priceEl.textContent = formatMoney(
      matchedVariant.price,
      locale,
      currency
    );
  });
})();
